import styled from 'styled-components';
import { mb, ml, mt } from '@upgrade/react-components/Spacing/core';
import { StyledSecondaryLgBtn } from '../styles';
import { StyledH6 } from '../typography';
import Image from '../Image';

export const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: ${({ $imagePosition }) => ($imagePosition === 'top' ? 'column' : 'row')};
  gap: ${({ theme }) => theme.spacing.sm};
  align-items: ${props => (props.isHorizontalSteps ? 'flex-start' : props.alignItems)};
  padding-top: ${props => (props.topBorder ? '1rem' : '0')};
  border-top: ${props => (props.topBorder ? `1px solid ${props.theme.palette.content}` : '0')};
  text-align: ${props => (props.alignItems === 'center' ? 'center' : 'left')};
  justify-content: ${props => (props.alignItems === 'center' ? 'center' : 'start')};

  h2,
  h5,
  p {
    text-align: ${props => (props.isHorizontalSteps ? 'left' : 'inherit')};
  }

  p {
    ${mb('none')};
  }

  @media (max-width: ${props => props.theme.mediaSm}) {
    li + li & {
      ${mt('lg')};
    }
  }
`;

export const StyledHeadingContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: ${({ $alignItems }) => ($alignItems === 'center' ? 'center' : 'flex-start')};
  justify-content: ${({ $alignItems }) => ($alignItems === 'center' ? 'center' : 'flex-start')};
  gap: ${({ theme }) => theme.spacing.sm};
  ${mb('sm')}

  .inline-icon {
    align-self: flex-start;
  }

  @media (min-width: ${props => props.theme.mediaSm}) {
    flex-direction: column;
  }
`;

export const StyledImage = styled(Image)`
  display: inline-block;
  flex: none;
  max-width: 100%;
  max-height: ${({ imageMaxHeight }) => imageMaxHeight};
  @media (min-width: ${props => props.theme.mediaXs}) {
    display: block;
  }

  ${({ centerImage }) => (centerImage ? 'margin: 0 auto' : 'margin-left: 0')};
`;

export const StyledList = styled.ul`
  list-style: none;
  list-style: initial;
  text-align: left;
`;

export const StyledInfoLink = styled(StyledSecondaryLgBtn)`
  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.lg.fontSize};
`;

export const StyledBorder = styled.hr`
  border: 2px solid ${props => props.theme.palette.semanticPositive};
  width: 2rem;
  ${ml('none')};
  ${mb('md')};
`;

export const StyledTextItem = styled(StyledH6)`
  padding: 0.5rem 1rem;
  border-radius: 5px;
  font-size: ${({ theme }) => theme.typography.sizes.text.desktop.md.fontSize};
  border: 2px solid ${props => props.theme.palette.contentReverse};
  margin-bottom: 1.2rem;
  display: inline-block;
`;

export const StyledListHeaderText = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.headings.desktop.sm.fontSize};
  margin-bottom: 0;
`;
